import { defineMessages } from 'react-intl';

export default defineMessages({
    Remove: {
        id: 'ml.common.component.MLPaymentMethodComponent.How do you want to pay?',
        defaultMessage: 'How do you want to pay?'
    },
    PaymentOptionHelpText: {
        id: 'ml.common.component.MLPaymentMethodComponent.What are the available payment options?',
        defaultMessage: 'What are the available payment options?'
    },
    MortgageOptionTooltipLabel: {
        id: 'ml.common.component.MLPaymentMethodComponent.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    MortgageOptionTooltipContent: {
        id: 'ml.common.component.MLPaymentMethodComponent.First year means ...',
        defaultMessage: 'First year means mortgage pays the premium on your behalf. Second year means you pay for the first year and mortgage pays after that.'
    },
    OtherPayor: {
        id: 'ml.common.component.MLPaymentMethodComponent.Other Payor',
        defaultMessage: 'Other Payor'
    },
    OtherPayorHelpText: {
        id: 'ml.common.component.MLPaymentMethodComponent.What is this?',
        defaultMessage: 'What is this?'
    },
    FirstYear: {
        id: 'ml.common.component.MLPaymentMethodComponent.First Year',
        defaultMessage: 'First Year'
    },
    SecondYear: {
        id: 'ml.common.component.MLPaymentMethodComponent.Second Year',
        defaultMessage: 'Second Year'
    },
    MortgageeLabel: {
        id: 'ml.common.component.MLPaymentMethodComponent.When will your mortgage begin paying your premium',
        defaultMessage: 'When will your mortgage begin paying your premium?'
    },
    PaymentMethodTooltipContent: {
        id: 'ml.common.component.MLPaymentMethodComponent.payment method tooltip content',
        defaultMessage: '<p><strong>Checking/savings account</strong> method indicates payment would be automatically deducted from your checking or savings account.  This payment method will not be available if your policy effective date is within seven days of today\'s date.</p><p><strong>Autopay</strong> payment methods indicate that payment will be automatically charged to your account on a recurring basis.  A consent form must be signed and returned for this payment option.</p><p><strong>Payroll deduction</strong> payment method means that payment will be automatically deducted by your employer on a recurring basis.</p><p><strong>Mortgage</strong> payment method indicates that your mortgage company will pay your insurance premium on your behalf.  This typically occurs when insurance premiums are included as part of your monthly mortgage payment.</p><p><strong>Send a bill</strong> payment method means that you will receive a bill which can be paid either online or by mail.</p>'
    },
    OtherPayorTooltipContent: {
        id: 'ml.common.component.MLPaymentMethodComponent.other payor tooltip content',
        defaultMessage: 'When the premium bills are to be sent to a person other than the named insured (example - a child is managing bills for an elderly parent).'
    },
    TotalPremium: {
        id: 'ml.common.component.MLPaymentMethodComponent.Total Premium',
        defaultMessage: 'Total Premium: {premium}'
    },
    InstallmentAmount: {
        id: 'ml.common.component.MLPaymentMethodComponent.Installment Amount',
        defaultMessage: 'Installment Amount: {installmentAmount}'
    },
    missingMortgage: {
        id: "ml.common.component.MLPaymentMethodComponent.Missing Mortgage",
        defaultMessage: '<p>Mortgage payment method can not be selected without a Mortgage being added to the policy.  Please select a different payment method or add a mortgage on <a>Additional Details</a></p>'
    },
    missingMortgageQB: {
        id: "ml.common.component.MLPaymentMethodComponent.Missing MortgageQB",
        defaultMessage: '<p>Please select a different payment method or add a mortgage on <a>Additional Details</a></p>'
    },
    endorsementMissingMortgage: {
        id: "ml.common.component.MLPaymentMethodComponent.Endorsement Missing Mortgage",
        defaultMessage: '<p>Mortgage payment method can not be selected without a Mortgage being added to the policy.  Please select a different payment method or add a mortgage on <a>Interested Parties</a></p>'
    },
    transferOffMercerQuestion: {
        id: 'ml.common.component.MLPayrollDeductComponent.transferOffMercerQuestion',
        defaultMessage: 'Send transfer off payroll transaction to Mercer?'
    },
    Yes: {
        id: 'ml.common.component.MLPayrollDeductComponent.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'ml.common.component.MLPayrollDeductComponent.No',
        defaultMessage: 'No'
    },
});
